import React, { useEffect } from 'react';
import useAudioRecorder from './../../../hooks/useAudioRecorder';
import styles from './AudioRecorder.module.css';
import RatioAudioPlayer from '../RatioAudioPlayer/RatioAudioPlayer';
import { HiMicrophone, HiStop, HiTrash, HiArrowUpCircle } from 'react-icons/hi2';
import useScrollToId from '../../../hooks/useScrollToId';
import Button from '../../ui/Button';

export default function AudioRecorder({ onSave, onRecordingStarted, triggerRecording = null, maxDuration = null}) {
  const {
    isRecording,
    recordedBlob,
    duration,
    error,
	isRecordingCapable,
    startRecording,
    stopRecording,
    reset
  } = useAudioRecorder(maxDuration);


  const scrollToId = useScrollToId(-100); 
  useEffect(() => {
    if (recordedBlob && onSave) {
      onSave(recordedBlob, duration, triggerRecording);
    }
  }, [recordedBlob]);

  useEffect(() => {
    if (isRecording && onRecordingStarted) {
      onRecordingStarted();
    }
  }, [isRecording]);

  useEffect(() => {
    if (isRecordingCapable() && triggerRecording != null) {
      handleRecording();
    }
  }, [triggerRecording]);

  const handleRecording = () => {
    reset();
    scrollToId('recordingbutton');
    startRecording();
  };

  if(isRecordingCapable() == false) return null;

  return (
    <div className={styles.recorderr}>
      <div id={"recordingbutton"} className={styles.controls}>
		<Button className={`${styles.recordButton} ${isRecording ? styles.recording : ''}`} onClick={() => { isRecording == true ? stopRecording(): handleRecording()}} aria-pressed={isRecording}>
            <HiMicrophone className={styles.micIcon}/>
		</Button>
		
        {false && recordedBlob && (
          <Button className={styles.resetBtn} onClick={reset}>
            <HiTrash /> Reset
          </Button>
        )}
      {isRecording && (
        <div className={styles.timer}> {duration}s </div>
      )}
      </div>

      {false && recordedBlob && (
        <div className={styles.preview}>
         {/* <audio controls src={URL.createObjectURL(recordedBlob)} />*/}
		  <RatioAudioPlayer audiodurationn={duration} src={URL.createObjectURL(recordedBlob)} />
          <div className={styles.meta}>?? Duration: {duration}s</div>
        </div>
      )}

      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
}
